import React from 'react';

import { Modal } from 'src/components/common';
import { InviteEmployersAdminsByCVAdminModalForm } from 'src/components/employer';
import { ModalId } from 'src/constants/modals';
import { useModal } from 'src/hooks/shared';

export const InviteEmployersAdminsByCVAdminModal: React.FC = () => {
  const { closeModal, switchClosability, isOpen } = useModal(
    ModalId.InviteEmployersAdminsByCVAdmin,
  );

  const onCloseModal = React.useCallback(() => {
    closeModal();
  }, [closeModal]);

  return (
    <Modal
      title="Invite Employers"
      headerPadding="32px 32px 0 32px"
      dialogProps={{
        onClose: onCloseModal,
        open: isOpen,
      }}
    >
      <InviteEmployersAdminsByCVAdminModalForm
        closeModal={onCloseModal}
        switchClosability={switchClosability}
      />
    </Modal>
  );
};
